import Icon from '../Icon';

const ConfirmationIcon = (props) => (
    <Icon width='25' height='24' viewBox='0 0 25 24' fill='none' {...props}>
        <path
            d='M16.8984 4.84958C15.6701 4.12659 14.2386 3.71191 12.7102 3.71191C8.14345 3.71191 4.44141 7.41396 4.44141 11.9807C4.44141 16.5474 8.14345 20.2494 12.7102 20.2494C17.2769 20.2494 20.9789 16.5474 20.9789 11.9807'
            stroke='#FFFDFB'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M8.68359 11.3012L12.0266 14.8L20.5058 6.08887'
            stroke='#FFFDFB'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </Icon>
);

export default ConfirmationIcon;
